import React from "react";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

export const PlayPauseIcon: React.FC<{ paused: boolean }> = ({ paused }) =>
  paused
    ? <PlayArrowIcon sx={{ fontSize: "18px", marginLeft: "2px" }} />
    : <PauseIcon sx={{ fontSize: "18px" }} />;

export const FullscreenButtonIcon: React.FC = () => (
  <FullscreenIcon sx={{ fontSize: "14px" }} />
);
